var agreements = agreements || {};

agreements.view = {
	init: function() {
		agreements.view.tabs();
		agreements.view.supplierFilter();
		site.expandGrid.init();
	},

	tabs: function() {
		var $tabs = $('main > .box .boxText');
		$tabs.tabs();
		$tabs.removeClass('ui-widget ui-widget-content ui-corner-all');
		$('#agreementTabs').removeClass('ui-widget-header ui-corner-all');
		$('#agreementTabs > li').removeClass('ui-state-default ui-corner-top');
		$('#tabsContainer').removeClass('ui-widget-content ui-corner-bottom');
	},

	supplierFilter: function() {
		var $grid = $('.suppliersGrid'),
			$suppliers = $('.supplier', $grid);

		$('ul#subcategories').on('click', 'a', function(e) {
			e.preventDefault();

			var $this = $(this),
				filter = $this.data('filter'),
				$subcategories = $this.closest('ul');

			$subcategories.addClass('filtering');

			setTimeout(function() {
				$subcategories.removeClass('filtering');

				$('a', $subcategories).removeClass('selected');
				$this.addClass('selected');

				$suppliers.removeClass('inactive').removeClass('expanded'); //.fadeIn();
				$('.expand', $suppliers).removeAttr('style');

				if (filter !== 'all') {
					$suppliers.removeClass('inactive').removeClass('expanded'); //fadeOut().
					$('.supplier:not(' + filter + ')', $grid).addClass('inactive'); //.fadeIn();
				}

				var ordered = $suppliers.sort(function (a, b) {
					var $a = $(a),
						$b = $(b),
						aActive = $a.hasClass('inactive'),
						bActive = $b.hasClass('inactive'),
						aTitle = $('.basic', $a).text().trim(),
						bTitle = $('.basic', $b).text().trim();

					if (aActive === bActive) {
						return aTitle > bTitle ? 1 : -1;
					}
					else {
						return aActive? 1 : -1;
					}
				});
				$grid.html(ordered);
			}, 600);

			//Update tender buttons
			var categoryId = filter.replace(/[^\d]+/,'');
			$('.tenderLink').each(function() {
				var $this = $(this);
				$this.attr('href', $this.data('url') + '/' + categoryId);
			});
		});

		$('#subcategoriesMobile').on('change', function() {
			var val = $(this).find("option:selected").val();
			$('a[data-filter*='+ val + ']', '#subcategories').trigger('click');
		});
	}
};

agreements.search = (function() {
	function init() {
		var searchForm = document.querySelector('#agreement_search');
		if (!searchForm) {
			return;
		}

		initAutoComplete(searchForm);
		initFormPost(searchForm);
	}

	function initFormPost(searchForm) {
		searchForm.addEventListener('submit', function(e) {
			if (e.target.q) {
				var v = e.target.q.value.replace(/\*$/, '');
				e.target.q.value = v + '*';
			}
			return true;
		});
	}

	function initAutoComplete(searchForm) {

		var quickUrl = searchForm.dataset.quick;
		if (!quickUrl) {
			return;
		}
		var q = searchForm.querySelector('#agreementsQ');
		if (!q) {
			return;
		}
		var $q = $(q).autocomplete({
			source: function(request, response) {
				$.ajax({
					url: quickUrl,
					dataType: 'json',
					data: {
						q: encodeURIComponent(request.term)
					},
					success: function (data) {
						response(data);
					}
				});
			},
			minLength: 3,
			autoFocus: true,
			select: autocompleteSelect,
			focus: autocompleteFocus,
		});
		var qInst = $q.autocomplete( "instance" );
		qInst._renderItem = renderItem;
		qInst._renderMenu = renderMenu;
	}

	function renderMenu($ul, items) {
		$ul.addClass('agreementQuick');
		var that = this;
		$.each( items, function( index, item ) {
			that._renderItemData( $ul, item );
		});
	}

	function renderItem(ul, item) {
		var $agreement = $('<span>').addClass('a').text(item.label);
		var $category = $('<span>').addClass('c').text(item.value.category);

		var $a = $('<a>').attr('href', item.value.url).append($category).append($agreement);
		return $('<li>').append($a).appendTo(ul);
	}

	function autocompleteSelect(event, ui) {
		if (ui.item && ui.item.value.url) {
			window.location = ui.item.value.url;
		}
		return false;
	}

	function autocompleteFocus (event, ui) {
		// Do nothing
		return false;
	}

	init();

	return {

	}
})();
